<template>
  <div
      class="report-option-card"
      :class="{
      selected,
      'report-option-card--small': small
    }"
      @click="$emit('select', option.value)"
  >
    <div class="report-option-card__image">

      <div class="report-option-card__image_svg">

        <img :src="option.preview" :alt="option.title">

      </div>


      <button
          type="button"
          class="report-option-card__zoom"
          @click.stop="$emit('preview', option)"
      >
        <i class="fas fa-search-plus"></i>
      </button>
    </div>

    <div class="report-option-card__content">
      <div class="report-option-card__top">
        <h5>{{ option.title }}</h5>
        <span v-if="option.badge" class="report-option-card__badge">
          {{ option.badge }}
        </span>
      </div>

      <p>{{ option.description }}</p>
    </div>
  </div>
</template>

<script>
import ReportOccurrenceLayoutType from "@/model/types/modules/checklist/ReportOccurrenceLayoutType";

export default {
  name: 'ReportOptionCard',
  data(){
    return{
      ReportOccurrenceLayoutType,
    }
  },
  props: {
    option: { type: Object, required: true },
    selected: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  }
}
</script>